exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading[data-v-a6d3f5e0]{text-align:center}.marker[data-v-a6d3f5e0]{position:absolute;top:0;left:0;width:100%;height:100%;z-index:500;background-color:hsla(0,0%,100%,.5)}.loadingtext[data-v-a6d3f5e0]{position:absolute;top:49%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a6d3f5e0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/loading.vue
// module id = 8
// module chunks = 0